import React, {useContext} from "react";
import {setContextOptions} from "@contexts/ContextMenu.tsx";

type ContextMenuType = {
    setDefaultContextMenuEnabled: (b: boolean) => void;
    defaultContextMenuEnabled: boolean;
    setContextOptions: (opt: setContextOptions) => void;
};

export const ContextMenu = React.createContext<ContextMenuType | null>(null)

/**
 * @see ContextMenuProvider
 */
export function useContextMenu(): ContextMenuType {
    const context = useContext(ContextMenu)
    if (context === null) {
        throw new Error("UseContextMenu deve ser usado dentro de um CtxMenuProvider.")
    }

    return context;
}